<template>
  <div class="item-bar">
    <!-- 购物车 -->
    <cart></cart>
      <!-- <el-button type="text" size="medium" style="color: #333333">
        <a
          class="returnreq-item"
          target="_blank"
          :href="constant.returnrequrl"
          >{{ constant.returnreqname }}</a
        >
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button> 
      <el-dropdown-menu slot="dropdown" class="dropdown">
        <el-dropdown-item
          v-for="(topMenuItemData, i) in menuItemDatas"
          :key="i"
        >
          <a class="drop-menu-item" target="_blank" :href="topMenuItemData.url">
            <span style="color: #333333">{{ topMenuItemData.name }}</span>
          </a>
        </el-dropdown-item>
      </el-dropdown-menu>
   -->

    <el-dropdown v-for="(topMenuItemData, i) in menuItemDatas" :key="i" size="mini" type="primary">
      
      <el-button type="text" size="medium" style="color: #333333">
        <a
          class="returnreq-item"
          target="_blank"
          @click="showForm(topMenuItemData.url)"
          >{{ topMenuItemData.name }}</a
        >
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
          
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(menuItem,j) in topMenuItemData.menuItems" :key="j">
          <el-button type="text" size="medium" style="color: #333333" @click="showForm(menuItem.url)">
            {{ menuItem.name }}
            <i class="el-icon--right"></i>
          </el-button>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>


  </div>
</template>
<script>
import Cart from "./Cart.vue";
export default {
  components: {
    cart: Cart,
  },
  data() {
    return {
      constant: this.$store.state.malMainPageConfig.constant,
    };
  },
  methods: {
    showForm: function (url) {
      if(url != ""){
        window.open(url);
      }   
    }
  },
  computed: {
    styleObject: function () {
      return {
        width: "18px",
        height: "20px",
        "margin-right": "4px ",
        display: "inline-block",
        color: "white",
      };
    },
    menuItemDatas: function () {
      return this.$store.state.malMainPageConfig.topMenuItem;
    },
  },
};
</script>

<style scoped lang="scss">
.item-ap {
  display: flex;
  align-items: center;
}
.menu-item {
  display: flex;
  align-items: center;
  text-decoration: none;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 1;
  color: #333333;
}
.returnreq-item {
  align-items: center;
  text-decoration: none;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 1;
  color: #333333;
}
.drop-menu-item {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: black;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 1;
  margin-top: 5px;
}
.item-bar {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  height: 40px;
  align-items: center;
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
  width: 435px;
}

.el-dropdown {
    display: inline-block;
    position: relative;
    color: #606266;
    font-size: 14px;
    margin-left: 23px;
}
</style>
